var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5886 32.4568H12.4113C10.4374 32.4568 8.83716 34.1021 8.83716 36.1315V38.553C8.83716 40.5824 10.4374 42.2276 12.4113 42.2276H67.5886C69.5625 42.2276 71.1627 40.5824 71.1627 38.553V36.1315C71.1627 34.1021 69.5625 32.4568 67.5886 32.4568Z",
    fill: "#D3DAE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6578 68.369H10.3422C8.22021 68.369 6.5 70.0142 6.5 72.0436V74.4651C6.5 76.4945 8.22021 78.1398 10.3422 78.1398H69.6578C71.7798 78.1398 73.5 76.4945 73.5 74.4651V72.0436C73.5 70.0142 71.7798 68.369 69.6578 68.369Z",
    fill: "#D3DAE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9935 32.4571H11.4736L22.1428 27.0573L36.0395 20.0251C38.6603 18.6944 41.8068 18.6944 44.4357 20.0251L58.3243 27.0573L68.9935 32.4571Z",
    fill: "#B7C2CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.3889 28.589L37.5566 23.4445C38.2603 23.0886 39.0611 22.8952 39.8619 22.8952C40.6627 22.8952 41.4635 23.0809 42.1673 23.4445L52.3349 28.589H27.3889Z",
    fill: "#8595A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.7534 32.4566H13.2466L23.1714 27.0567H56.8286L66.7534 32.4566Z",
    fill: "url(#paint0_linear_3536_25291)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.563 42.2281H16.3914V68.3687H24.563V42.2281Z",
    fill: "#D3DAE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.563 42.2281H16.3914V47.9684H24.563V42.2281Z",
    fill: "url(#paint1_linear_3536_25291)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.3916 68.3694H24.5632V62.6291H16.3916V68.3694Z",
    fill: "url(#paint2_linear_3536_25291)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5808 42.228H29.4092V68.3685H37.5808V42.228Z",
    fill: "#D3DAE2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.5808 42.228H29.4092V47.9682H37.5808V42.228Z",
    fill: "url(#paint3_linear_3536_25291)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.4009 68.3685H37.5725V62.6283H29.4009V68.3685Z",
    fill: "url(#paint4_linear_3536_25291)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5903 42.228H42.4187V68.3685H50.5903V42.228Z",
    fill: "#D3DAE2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.5903 42.228H42.4187V47.9682H50.5903V42.228Z",
    fill: "url(#paint5_linear_3536_25291)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.426 68.369H50.5977V62.6287H42.426V68.369Z",
    fill: "url(#paint6_linear_3536_25291)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3069 42.2308H55.1353V68.374H63.3069V42.2308Z",
    fill: "#D3DAE2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.3069 42.2308H55.1353V47.9716H63.3069V42.2308Z",
    fill: "url(#paint7_linear_3536_25291)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.135 68.3744H63.3066V62.6336H55.135V68.3744Z",
    fill: "url(#paint8_linear_3536_25291)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40 26C46.6274 26 52 20.6274 52 14C52 7.37258 46.6274 2 40 2C33.3726 2 28 7.37258 28 14C28 20.6274 33.3726 26 40 26Z",
    fill: "#FFE296"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2294 8.80595L42.0197 10.6883C42.2115 11.1478 42.6565 11.4591 43.1629 11.4887L45.2577 11.637C46.4546 11.7185 46.938 13.1636 46.025 13.9121L44.4213 15.2165C44.03 15.5352 43.8612 16.0391 43.984 16.5134L44.4904 18.4847C44.7819 19.6112 43.5082 20.5079 42.4877 19.8928L40.7076 18.8182C40.2779 18.5588 39.7255 18.5588 39.2958 18.8182L37.5157 19.8928C36.4952 20.5079 35.2215 19.6112 35.513 18.4847L36.0194 16.5134C36.1422 16.0391 35.9734 15.5352 35.5821 15.2165L33.9784 13.9121C33.0577 13.1636 33.5488 11.7185 34.7457 11.637L36.8404 11.4887C37.3469 11.4517 37.7919 11.1404 37.9837 10.6883L38.774 8.80595C39.2267 7.73135 40.7997 7.73135 41.2524 8.80595H41.2294Z",
    fill: "#FFB341"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3536_25291",
    x1: 40.0038,
    y1: 32.2399,
    x2: 40.0038,
    y2: 28.0934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A89F9D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A89F9D",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A89F9D",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A89F9D",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A89F9D",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89F9D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3536_25291",
    x1: 20.4772,
    y1: 42.5917,
    x2: 20.4772,
    y2: 47.2412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#919DAC",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919DAC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3536_25291",
    x1: 20.4774,
    y1: 68.0058,
    x2: 20.4774,
    y2: 63.3563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919DAC",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919DAC",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919DAC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3536_25291",
    x1: 33.495,
    y1: 42.5916,
    x2: 33.495,
    y2: 47.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#919DAC",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919DAC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3536_25291",
    x1: 33.4867,
    y1: 68.0049,
    x2: 33.4867,
    y2: 63.3555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919DAC",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919DAC",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919DAC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3536_25291",
    x1: 46.5045,
    y1: 42.5916,
    x2: 46.5045,
    y2: 47.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#919DAC",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919DAC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3536_25291",
    x1: 46.5118,
    y1: 68.0054,
    x2: 46.5118,
    y2: 63.3559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919DAC",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919DAC",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919DAC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3536_25291",
    x1: 59.2211,
    y1: 42.5944,
    x2: 59.2211,
    y2: 47.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#919DAC",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919DAC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3536_25291",
    x1: 59.2208,
    y1: 68.0108,
    x2: 59.2208,
    y2: 63.3608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919DAC",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919DAC",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919DAC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.d9263ed126689456e1a8cd1e9f9c3e86.svg";
export { ForwardRef as ReactComponent };